/**
 * "N lines unpriced" — shown beside an order amount whenever the subtotal
 * left lines out because they have no unit price yet (kanban c81b5b33).
 *
 * Display only: the marker never changes pricing. It renders nothing when
 * every line is priced or when the count is unknown, so callers can drop it
 * next to any amount without a guard.
 */
import { unpricedLinesLabel } from '../../utils/orderTotals';
import styles from './UnpricedLinesMarker.module.css';

interface UnpricedLinesMarkerProps {
  count: number | null | undefined;
  /** Where the marker sits, for the data-testid: "orders-list" / "order-header". */
  placement: string;
  /** Optional id suffix so a list can carry one marker per row. */
  idSuffix?: string;
}

export default function UnpricedLinesMarker({ count, placement, idSuffix }: UnpricedLinesMarkerProps) {
  const label = unpricedLinesLabel(count);
  if (!label) return null;
  const testId = idSuffix ? `unpriced-lines-${placement}-${idSuffix}` : `unpriced-lines-${placement}`;
  return (
    <span
      className={styles.marker}
      data-testid={testId}
      title={`${label}: the amount shown leaves ${count === 1 ? 'that line' : 'those lines'} out until a price is set`}
    >
      {label}
    </span>
  );
}
